import clsx from 'clsx';
import React, { useRef, useState } from 'react';

import searchIcon from 'images/search_icon.svg';

import { search_page_path } from '@routes';

export default function SearchBar({
  isSearchLandingPage,
  scope,
}: {
  isSearchLandingPage: boolean;
  scope: string;
}) {
  const [query, setQuery] = useState('');
  const textAreaRef = useRef<HTMLTextAreaElement>();

  const handleChange = (e) => setQuery(e.target.value);

  return (
    <div
      className={clsx('mt-20 md:mt-40', {
        'px-16': isSearchLandingPage,
      })}
    >
      <div
        className={clsx({
          'mx-auto max-w-[600px]': isSearchLandingPage,
        })}
      >
        <form id="form_id" action={search_page_path()} method="get" data-id="search-form">
          <div className="flex flex-col gap-16">
            <div className="flex items-center gap-12">
              <img src={searchIcon} width="24" height="24" alt="" />
              <div>
                <h1 className="m-0 p-0 text-headline-xs font-bold leading-none">
                  Search The Information
                </h1>
                <p className="m-0 text-caption italic">Powered by AI</p>
              </div>
            </div>
            <textarea
              name="query"
              className={clsx(
                // add min-width and max-width classes to prevent horizontal resizing of textarea
                'min-h-[100px] w-full min-w-full max-w-full rounded-2 px-16 py-10',
                'border-gray-300 text-body-sm text-grayscale-50'
              )}
              value={query}
              onChange={handleChange}
              ref={textAreaRef}
            />
            <button
              type="submit"
              className={clsx(
                'border-none bg-primary-red font-sans text-button-md uppercase !text-white',
                'flex h-40 items-center justify-center self-end rounded-2 xs:w-[200px]',
                'transition-colors hover:bg-pro-red focus:bg-pro-red'
              )}
            >
              Search
            </button>
          </div>
          <input type="hidden" name="scope" value={scope} />
        </form>
      </div>
    </div>
  );
}
